/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const pipelineStageCampaignDataSchema = z.object({
	candidates: z.array(
		z.object({
			id: z.string(),
			name: z.string().nullable(),
			email: z.string().nullable(),
			phone: z.string().nullable(),
			formSubmission: z.object({
				id: z.string(),
				formId: z.string(),
				candidateId: z.string(),
				questions: z.array(
					z.object({
						question: z.string(),
						position: z.string(),
						answers: z.array(
							z.object({
								answer: z.string().nullable(),
								optionId: z.string().nullable(),
								updatedAt: z.iso.datetime(),
							}),
						),
						updatedAt: z.iso.datetime(),
						options: z.array(z.object({ id: z.string(), label: z.string() })).nullable(),
					}),
				),
				score: z.object({
					percentage: z.number(),
					total: z.number(),
					max: z.number(),
					breakdown: z.array(
						z.object({
							questionId: z.string(),
							rawScore: z.number(),
							weight: z.number(),
							weightedScore: z.number(),
							maxScore: z.number(),
						}),
					).nullable(),
				}).nullable(),
				thankYouScreen: z.object({
					id: z.string(),
					formId: z.string(),
					minScoreRange: z.number(),
					maxScoreRange: z.number(),
					title: z.string(),
					description: z.string(),
					organisationName: z.string().nullable(),
					logo: z.object({
						id: z.string(),
						name: z.string(),
						fileName: z.string(),
						category: z.union([z.literal('image'), z.literal('file')]),
						mimeType: z.string().nullable(),
						size: z.number(),
						humanReadableSize: z.string(),
						url: z.string(),
						collectionName: z.union([
							z.literal('ad-asset'),
							z.literal('baked-story'),
							z.literal('baked-feed'),
							z.literal('story'),
							z.literal('feed'),
							z.literal('landing-page'),
							z.literal('logo'),
							z.literal('generated'),
							z.literal('uploaded'),
							z.literal('imported'),
							z.literal('candidate-files'),
							z.literal('custom-font'),
							z.literal('design'),
							z.literal('whatsapp-profile'),
						]),
						width: z.number(),
						height: z.number(),
						isPlaceholder: z.boolean(),
						isGenerating: z.boolean(),
						createdAt: z.iso.datetime(),
						isGenerated: z.boolean().default(false),
						startedGenerationAt: z.iso.datetime().nullable(),
						finishedGenerationAt: z.iso.datetime().nullable(),
						meta: z.record(z.string(), z.unknown()).nullable(),
					}).nullable(),
					updatedAt: z.iso.datetime(),
					isGenerated: z.boolean().default(false),
					startedGenerationAt: z.iso.datetime().nullable(),
					finishedGenerationAt: z.iso.datetime().nullable(),
					meta: z.record(z.string(), z.unknown()).nullable(),
				}).nullable(),
				createdAt: z.iso.datetime(),
				updatedAt: z.iso.datetime(),
				meta: z.record(z.string(), z.unknown()).nullable(),
				additionalQuestions: z.array(
					z.object({
						id: z.string(),
						additionalQuestionId: z.string(),
						questionLabel: z.string().nullable(),
						questionType: z.union([
							z.literal('select'),
							z.literal('text'),
							z.literal('open_text'),
							z.literal('file'),
							z.literal('datetime'),
						]).nullable(),
						questionAttribute: z.union([
							z.literal('name'),
							z.literal('email'),
							z.literal('phone'),
							z.literal('contact_consent'),
							z.literal('cv'),
						]).nullable(),
						position: z.number(),
						answers: z.array(
							z.object({
								id: z.string(),
								answer: z.string().nullable(),
								optionId: z.string().nullable(),
								file: z.object({
									id: z.string(),
									candidateId: z.string(),
									name: z.string(),
									fileName: z.string(),
									mimeType: z.string().nullable(),
									size: z.number(),
									url: z.string().nullable(),
									previewUrl: z.string().nullable(),
									createdAt: z.iso.datetime(),
									metadata: z.object({
										sourceEmailId: z.string().nullable(),
										sourceEmailSubject: z.string().nullable(),
									}).nullable(),
									scanStatus: z.union([
										z.literal('queued'),
										z.literal('scanning'),
										z.literal('clean'),
										z.literal('infected'),
										z.literal('error'),
										z.literal('skipped'),
									]).nullable(),
									scanSignature: z.string().nullable(),
									attribute: z.literal('cv').nullable(),
								}).nullable(),
							}),
						),
						createdAt: z.iso.datetime(),
					}),
				),
			}).nullable(),
			submissionCount: z.number(),
			pipelineStageId: z.string().nullable(),
			pipelineStageType: z.string().nullable(),
			notes: z.array(
				z.object({
					id: z.string(),
					candidateId: z.string(),
					userId: z.string().nullable(),
					userName: z.string().nullable(),
					userEmail: z.string().nullable(),
					content: z.string(),
					editedAt: z.iso.datetime().nullable(),
					createdAt: z.iso.datetime(),
					updatedAt: z.iso.datetime(),
					deletedAt: z.iso.datetime().nullable(),
				}),
			),
			createdAt: z.iso.datetime().nullable(),
			disqualificationReason: z.string().nullable(),
			hasUnreadEmails: z.boolean().default(false),
			unreadEmailCount: z.number().default(0),
			hasUnreadWhatsApp: z.boolean().default(false),
			unreadWhatsAppCount: z.number().default(0),
			hasOrphanedStage: z.boolean().nullable().default(false),
			interviewBadgeState: z.union([
				z.literal('confirmed'),
				z.literal('pending'),
				z.literal('completed'),
				z.literal('no_show'),
				z.literal('expired'),
				z.literal('cancelled'),
			]).nullable(),
			latestInterviewBooking: z.object({
				status: z.union([z.literal('confirmed'), z.literal('cancelled')]),
				candidateAttended: z.boolean().nullable(),
				scheduledAt: z.iso.datetime(),
			}).nullable(),
			files: z.object({
				total: z.number().default(0),
				tagged: z.object({ cv: z.number().default(0) }).default({ 'cv': 0 }),
			}).default({ 'total': 0, 'tagged': { 'cv': 0 } }),
			profileCounts: z.object({
				workHistory: z.number().default(0),
				education: z.number().default(0),
				licenses: z.number().default(0),
			}).default({ 'workHistory': 0, 'education': 0, 'licenses': 0 }),
		}),
	),
	pipelineStages: z.array(
		z.object({
			id: z.string(),
			name: z.string(),
			position: z.number(),
			locked: z.boolean().default(false),
			type: z.string().nullable(),
		}),
	),
	unreadEmailCount: z.number().default(0),
	unreadWhatsAppCount: z.number().default(0),
})

export type PipelineStageCampaignDataSchema = z.infer<typeof pipelineStageCampaignDataSchema>
